<template>
  <div class="bgEventTable-ctn" :style="style" :class="{ isLongLanguage }">
    <div class="bgEventTable-ctn_title">
      <!-- <div class="bgEventTable-titleOneRow_label" v-show="high">{{ what }}</div> -->
      <!-- <div class="bgEventTable-titleOneRow_label bgEventTable-titleOneRow_label--white" v-show="low">{{ what }}</div> -->
      <div class="bgEventTable-titleOneRow_label">{{ what }}</div>
      <div v-show="high" class="bgEventTable-titleOneRow_content">{{ $t('High BG Event') }} ( {{ $t('Total Number') }} {{ total }} )</div>
      <div v-show="low" class="bgEventTable-titleOneRow_content">{{ $t('Low BG Event') }} ( {{ $t('Total Number') }} {{ total }} )</div>
    </div>
    <div class="bgEventTable-ctn_oneRow bgEventTable-ctn_oneRow--first">
      <div class="bgEventTable-ctnOneRow_label">{{ values[0] ? values[0]['time'] : '' }}</div>
      <div class="bgEventTable-ctnOneRow_content">{{ values[0] ? values[0]['number'] : '' }}</div>
    </div>
    <div class="bgEventTable-ctn_oneRow">
      <div class="bgEventTable-ctnOneRow_label">{{ values[1] ? values[1]['time'] : '' }}</div>
      <div class="bgEventTable-ctnOneRow_content">{{ values[1] ? values[1]['number'] : '' }}</div>
    </div>
    <div class="bgEventTable-ctn_oneRow bgEventTable-ctn_oneRow--last">
      <div class="bgEventTable-ctnOneRow_label">{{ values[2] ? values[2]['time'] : '' }}</div>
      <div class="bgEventTable-ctnOneRow_content">{{ values[2] ? values[2]['number'] : '' }}</div>
    </div>
  </div>
</template>
<script>
import reDrawTrigger from '@mx/reDrawTrigger'

import { derrorFactory, errorFactory, dlogFactory } from '@u/log'
const derror = derrorFactory('BGEventTable', false)
const error = errorFactory('BGEventTable', false)
const log = dlogFactory('BGEventTable', true)

let _id = 1
export default {
  name: 'CBGEventTable',
  mixins: [reDrawTrigger],
  props: {
    what: {
      type: [String],
      default: () => 'CGM'
    },
    high: {
      type: [Boolean],
      default: () => true
    },
    highTotal: {
      type: [Number, String],
      default: () => 0
    },
    low: {
      type: [Boolean],
      default: () => false
    },
    lowTotal: {
      type: [Number, String],
      default: () => 0
    },
    values: {
      type: [Array],
      default: () => []
    }
  },
  data() {
    _id++
    const id = `cpie_${+new Date()}_${_id}`
    return {
      id
    }
  },
  computed: {
    dotStyle1() {
      const { colors = [] } = this
      return { 'backgroundColor': colors[0] }
    },
    dotStyle2() {
      const { colors = [] } = this
      return { 'backgroundColor': colors[1] }
    },
    w() {
      const { ds, isLongLanguage } = this

      if (isLongLanguage) {
        // return ds * (426 / 1740)
        // return ds * (436 / 1740)
        return ds * (500 / 1740)
      } else {
        return ds * (380 / 1740)
      }
    },
    style() {
      const { w, zoomRatio, high, ds, isLongLanguage } = this
      const rst = { width: w + 'px', zoom: zoomRatio }
      
      if (high) {
        rst['marginRight'] = ds * (40 / 1740) + 'px'
        if (isLongLanguage) {
          rst['marginRight'] = ds * (20 / 1740) + 'px'
        }
      }

      if (isLongLanguage) {
        rst['zoom'] = zoomRatio * 0.88
      }
      
      return rst
    },
    total() {
      const { values = [] } = this
      const total = values.length

      return (String(total)).padStart('0', 2)
    }
  },
  mounted() {
    this.renderPies(false)
  },
  beforeDestroy() {
    try {
      if (this._myChart) {
        this._myChart.dispose() // 销毁echarts实例
        this._myChart = null
      }
    } catch (err) {
      error('被捕获:' + err)
    }
  },
  methods: {
    refreshTriggered() {
      derror(`CharPie ${this.id}, this.refreshTriggered`)
      this.renderPies(true)
    },
    renderPies(isUpdate = false) {
      // const { id } = this
      // const ds = this.ds
      if (!isUpdate) {
        this.initChart()
      } else {
        this.updateChart()
      }
    },
    getOpt(_val = []) {
      const { title, lfs } = this
      const values = _val.map(v => {
        return Object.assign({}, v, {
          name: this.$t(v.name)
        })
      })
      const ds = this.ds
      
      const o = {
        title: {
          padding: [(14 / 12) * lfs, 0, 0, (15 / 12 * lfs)],
          show: false,
          text: title,
          textStyle: {
            fontSize: lfs,
            color: 'black',
            fontWeight: 'bold'
          }
        },
        animation: false,
        tooltip: {
          show: false,
          trigger: 'item'
        },
        legend: {
          show: false
        },
        color: this.colors,
        series: [
          {
            name: 'Insulin injection',
            type: 'pie',
            radius: ['71%', '100%'],
            avoidLabelOverlap: false,
            // itemStyle: { // 会形成border、弧度
            //   borderRadius: 10,
            //   borderColor: '#fff',
            //   borderWidth: 2
            // },
            itemStyle: {
              borderRadius: 3
            },
            selectMode: true,
            selectedOffset: 5,
            showAbove: false,
            label: {
              normal: {
                show: false,
                fontSize: 12,
                position: 'outer', // 让labelLine末端对齐
                alignTo: 'labelLine', //
                distanceToLabelLine: 0,
                padding: [-20, 0, 0, 0],
                formatter: params => {
                  return `{pre|${params.value}U  (${params.percent.toFixed(0) + '%'})}\n{name| ${params.name}}\n`
                },
                rich: {
                  pre: {
                    color: '#070C12',
                    fontFamily: 'PingFang-SC-Bold',
                    fontWeight: '700',
                    fontSize: 14,
                    align: 'left',
                  },
                  name: {
                    color: '#515669',
                    fontSize: 10,
                    padding: [5, 0, 5, -4],
                    align: 'left',
                  }
                }
              },
              emphasis: {
                show: false
              }
            },
            emphasis: {
              disabled: true,
              scaleSize: 3// ,
              // label: {
              //   show: true,
              //   fontSize: 40,
              //   fontWeight: 'bold'
              // }
            },
            labelLine: {
              show: false
            },
            labelLayout: (params) => {
              const isLeft = params.labelRect.x < ds / 2
              // points：labelLine的三个点坐标，改变第三个点的x坐标，增加length2的长度，达到label在labelLine线上
              const points = params.labelLinePoints
              if (isLeft) { // 左边
                points[2][0] = params.labelRect.x
              } else {
                points[2][0] = params.labelRect.x + params.labelRect.width
              }
              return {
                labelLinePoints: points
              }
            },
            data: values
          }
        ]
      }
      return o
    },
    initChart() {
      log(`initChart`)
      const { id } = this
      const canvasid = `wtpie2_${id}`
      try {
        const myChart = this.$echarts.init(document.getElementById(`${canvasid}`), null, { renderer: 'svg' })
        const opt = this.getOpt(this.values)
        
        myChart.setOption(opt)
        
        // 默认选中高亮
        const index = 0
        // myChart.dispatchAction({
        //   type: 'select',
        //   dataIndex: index
        // })
        // highlight后，才会显示标线这些,并且进行放大
        myChart.dispatchAction({
          type: 'highlight',
          dataIndex: 0
        })
        
        this._myChart = myChart
      } catch (err) {
        error('被捕获:' + err)
      }      
    },
    updateChart() {
      log(`updateChart, values: ${this.values}`)
      const myChart = this._myChart
      const newOpt = this.getOpt(this.values)
      this.$nextTick(() => {
        try {
          if (myChart) {
            myChart.setOption(newOpt)            
          }
        } catch (err) {
          error('被捕获:' + err)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixin';

.bgEventTable-ctn {
    margin-top: calc(10 / 16) * 1rem;
    @include flexColumn(flex-start);
    
    .bgEventTable-ctn_title {
        @include bBox();
        /* padding: 0 calc(5 / 16) * 1rem; */
        text-indent: 0; 
        @include flexRow(flex-start, center);
        height: 40px;
        width: 100%;
        border-radius: 4px;
        font-weight: bold;
        .bgEventTable-titleOneRow_label {
            background-color: white;
            text-align: left;
            width: (58 / 359) * 100%;
            font-size: 16px;
        }
        .bgEventTable-titleOneRow_label--white {
            color: white;
        }
        .bgEventTable-titleOneRow_content {
            background-color: $colorGluMesurementLabelBg;
            color: $colorGluMesurementFont;
            height: 100%;
            @include flexRow(flex-start, center);
            font-size: 16px;
            text-indent: (20 / 16) * 1em;
            flex: 1;
            $r: 4px;
            border-radius: $r;
        }
    }

    &.isLongLanguage .bgEventTable-ctn_title .bgEventTable-titleOneRow_label {
        width: (38 / 359) * 100%;
        /* background: red; */
    }
    
    .bgEventTable-ctn_oneRow {
        $h: 40px;
        $r: 4px;
        width: 100%;
        font-weight: normal;
        border-bottom: 0.5px solid $colorEchartStripeInnerBorder;
        > * {
            display: inline-block;
            vertical-align: middle;
            @include heightMiddle($h);
        }
        .bgEventTable-ctnOneRow_label {
            color: rgba(0, 0, 0, 0.5);
            color: $colorGluMesurementFont;
            font-size: 12px;
            font-weight: normal;
            width: 63 / 220 * 100%;
            text-align: center;
            @include heightMiddle($h);
            width: (123 / 359) * 100%;
        }
        
        .bgEventTable-ctnOneRow_content {
            background-color: $colorGluMesurementLabelBg;
            color: $colorGluMesurementFont;
            width: 157 / 220 * 100%;
            @include heightMiddle($h);
            text-align: center;
            width: (236 / 359) * 100%;
            font-size: 12px;
            > div {
                @include flexRow(flex-start, center);
                word-wrap: break-word;
                word-break: normal;
                line-height: initial;
                width: 100%;
                height: 100%;
                @include bBox();
            }
            .ctn-unit {
                margin-left: 0.4em;
            }
        }
        
        &.bgEventTable-ctn_oneRow--first {
            margin-top: 10px;
            .bgEventTable-ctnOneRow_content {
                border-top-left-radius: $r;
                border-top-right-radius: $r;
            }
        }
        &.bgEventTable-ctn_oneRow--last {
            border-bottom-right-radius: $r;
            .bgEventTable-ctnOneRow_content {
                border-bottom-left-radius: $r;
                border-bottom-right-radius: $r;
            }
        }
    }
}
</style>
